module.exports = __webpack_public_path__ + "fonts/VetoSans-Bold_1.1e694536.ttf";